import {useState, useEffect} from 'react'
import { TextField } from '@mui/material'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import UserAdminDialogs from '../../common/components/admin/AdminEditUsersDialog';
import UsersRows from '../../common/components/admin/UsersRows';
import ReceiverDialog from '../../common/components/Dialogs/ReceiverDialog';
import { createService } from '../../common/services/serviceFactory';

function UsersSection() {

    const [searchBarValue, setSearchBarValue] = useState("")

    const [openEditDialog, setOpenEditDialog] = useState(false)
    const [openReceiverDialog, setOpenReceiverDialog] = useState(false)

    const [receiversUser, setReceiversUser] = useState({})
    const [updateUser, setUpdateUser] = useState({
        clientName:"William",
        email:"ironmorew@gmail.com",
        isAuth: true,
        receivers: []
    })
    const [allUsers, setAllUsers] = useState([])

    const [receiverToUpdate, setReceiverToUpdate] = useState({
        receiverName:"",
        phone:"",
        township: "",
        province : "",
        distribution: "",
        principalStreet : "",
        middleStreets : "",
        buildingNumber: "",
        apartment: "",
        carnet: ""
    })

    const receiverUpdate = async () => {
        const userService = createService('users');
        const token = localStorage.getItem('accessToken');
        try {
            const updatedReceiver = await userService.updateReceiver(receiversUser._id, receiverToUpdate._id, receiverToUpdate, token);
            setAllUsers(prevUsers => {
                return prevUsers.map(user => {
                    if (user._id === receiversUser._id) {
                        return {
                            ...user,
                            receivers: user.receivers.map(receiver =>
                                receiver._id === updatedReceiver._id ? updatedReceiver : receiver
                            )
                        };
                    }
                    return user;
                });
            });
            setOpenReceiverDialog(false);
        } catch (error) {
            console.error("Error updating receiver:", error);
        }
    };

    useEffect(() => {
        const userService = createService('users');
        const token = localStorage.getItem("accessToken");
        userService.getAll(token)
            .then((data) => {
                setAllUsers(data);
            })
            .catch(error => console.error("Error fetching users:", error));

   },[])

    const handleData = (event) => {
        const text = event.target.value;
        setSearchBarValue(text);
    }

    const handleDataReceiver = input => e => setReceiverToUpdate({...receiverToUpdate, [input]: e.target.value})

  return (
    <div className='flex justify-center align-center flex-column'>
      <div style={{margin: "15px"}} className='flex justify-center'>
        <TextField 
          name={"nameOfTheCurrency"}
          sx={{ width : "300px" }}
          value={searchBarValue}
          label={"Filtrar Por Correo"}
          onChange={handleData}
          required
        />
      </div>
      <div style={{width: "95%"}} className="flex justify-center align-center">
        <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
          <TableCell>Destinatarios</TableCell>
            <TableCell>Nombre del Usuario</TableCell>
            <TableCell align="right">Email</TableCell>
            <TableCell align="right">Estado</TableCell>
            <TableCell align="right">Botones</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {allUsers.filter((val)=>{
                if(searchBarValue===""){
                    return val;
                } else if (val.email.toLowerCase().includes(searchBarValue.toLowerCase())){
                    return val;
                }
                return null; // Added to ensure a return value in all cases
              }).map((user) => (
                    <UsersRows 
                        row={user} 
                        setOpenEditDialog = {setOpenEditDialog} 
                        setUpdateUser={setUpdateUser}
                        setReceiverToUpdate={setReceiverToUpdate}
                        setReceiversUser={setReceiversUser}
                        setOpenReceiverDialog={setOpenReceiverDialog}
                    />
            

          ))}
        </TableBody>
      </Table>
    </TableContainer>
    </div>

    <UserAdminDialogs
        setAllUser       =    {setAllUsers}
        selectedUser     =    {updateUser}
        updateOpenDialog =    {openEditDialog}
        setUpdateOpenDialog = {setOpenEditDialog}
        updateUser       =    {updateUser}
        setUpdateUser    =    {setUpdateUser}
    />

    <ReceiverDialog
      updateValues  = {receiverToUpdate}
      openDialog    = {openReceiverDialog}
      setOpenDialog = {setOpenReceiverDialog}
      callToActionFunction = {receiverUpdate}
      handleData    = {handleDataReceiver}
    />

    </div>
  )
}

export default UsersSection